import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/Profile/Credentials/credentials.container"
    ).then((module) => ({
        default: module.ProfileCredentialsContainer
    }))
);
